import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';
export default {
  name: 'FormPhoneTooltip',
  components: {
    popper: Popper
  },
  props: {
    forceShow: {
      type: Boolean,
      default: false
    }
  }
};